import { observe, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Prompt, withRouter } from 'react-router-dom';
import { Button, Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { ReceiveDispatchModal } from 'src/Components/Main/Dispatch/ReceiveDispatch/ReceiveDispatchModal';
import { IDispatchTruck } from 'src/Interfaces/DispatchInterface';
import { MessageStore } from 'src/Stores/Messages/Messages';
import { TestsStore } from 'src/Stores/Tests/TestsStore';
import { UserStore } from 'src/Stores/User/UserStore';
import DeepCopy from 'src/UtilityFunctions/DeepCopy';
import { IEBPExpenseType, IInventoryEBP, IInventoryProduct, IProduct, IProductCategory, ITest } from '../../../../../Interfaces/TestInterface';
import { IWell } from '../../../../../Interfaces/WellInterface';
import { decimalPlaces } from '../../../../../UtilityFunctions/DecimalPlaces';
import DataTable from '../../../../DataTable';
import { EInput, EInputMask } from '../../../../EInput';
import Footer from '../../../../Footer';
import WorkflowHeader from '../../../WorkflowHeader';
import TotalHeader from '../TotalHeader';

// import { any } from 'prop-types';
// import { text } from '@fortawesome/fontawesome-svg-core';

interface IList {
    headers: any[];
    rows: any[];
}

@inject('stores')
@observer
class Products extends React.Component {
    public props: any;
    private mask: any = new EInputMask();
    private modalDataSet: IList;
    private dataSet: IList;
    private productList: IProduct[] = [];
    private newProduct: IProduct = new IProduct();
    private test: ITest = new ITest();
    public TestsStore: TestsStore;
    private UserStore: UserStore;
    private testDisposer: any;
    private well: IWell = new IWell();
    public WellsStore: any;
    private wellDisposer: any;
    private MessageStore: MessageStore;


    public state = {
        closingAmountDirty: [] as boolean[],
        dataSet: this.dataSet, 
        expenseList: [] as IEBPExpenseType[],
        expenseListMaster: [] as IEBPExpenseType[],
        isDirty: false,
        modal: false,
        modalDataSet: this.modalDataSet,
        modalDataSetMaster: this.modalDataSet,
        nameFilter: '',
        newInventoryList: [] as boolean[],
        newInventoryListMaster: [] as boolean[],
        newProduct: this.newProduct,
        pendingDispatchModal: false,
        pickupDispatchModal: false,
        productCategories: [],
        productList: this.productList,
        productListMaster: this.productList,
        productModal: false,
        receiveDispatchModal: false,
        saveClicked: false,
        showMasterItems: false,
        sortOrder: 1,
        test: this.test,
        well: this.well
    };

    constructor(props: any) {
        super(props);

        this.TestsStore = this.props.stores.TestsStore;
        this.WellsStore = this.props.stores.WellsStore;
        this.MessageStore = this.props.stores.MessageStore;
        this.UserStore = this.props.stores.UserStore;
    }

    public componentDidMount() {
        if ( this.props.stores.WellsStore.well && this.props.stores.TestsStore.test ) {
            const test = toJS(this.TestsStore.test);
            this.defaultSort(test);
            this.setState({
                test,
                well: toJS(this.WellsStore.well)
            }, () => {
                this.getProductList().then(() => {
                    this.getMasterProductList();
                    this.getProductCategories();
                });
                this.getExpenseTypes().then(() => {
                    this.getMasterExpenseList();
                });
                this.formatDataTable();
            });
        } else {
            this.TestsStore.getTestDetails(this.props.match.params.taskId, this.props.match.params.wellId);
            this.WellsStore.getWellDetails(this.props.match.params.wellId);
        }
        this.createDisposers();
    }



    public createDisposers() {
        this.testDisposer = observe(this.TestsStore, 'test', (change: any) => {
            const test = toJS(change.newValue);
            this.defaultSort(test);
            this.setState({
                test
            }, () => {
                this.formatDataTable();
            });
        });
        this.wellDisposer = observe(this.WellsStore, 'well', (change: any) => {
            const well = toJS(change.newValue);
            this.setState({
                well
            }, () => {
                this.getProductList().then(() => {
                    this.getMasterProductList();
                    this.getProductCategories();
                });
                this.getExpenseTypes().then(() => {
                    this.getMasterExpenseList();
                });
            });
        });
    }

    private getExpenseTypes() {
        return this.TestsStore.getExpenseTypes(this.props.match.params.wellId)
        .then(
            (data: any) => {
                this.setState({
                    expenseList: data
                }, () => {
                    this.formatModalDataTable();
                });
            }
        );
    }

    private getMasterExpenseList() {
        this.TestsStore.getExpenseTypes()
            .then(expenseMasterList => {
                if (expenseMasterList) {
                    const expenseListMaster = expenseMasterList.filter((expense: IEBPExpenseType) => 
                        !this.state.expenseList.some(p => p.id === expense.id)
                    );
                    this.setState({expenseListMaster}, () => {
                        this.formatModalDataTable();
                    });
                }
            });
    }

    private defaultSort = (test: ITest) => {
        if (test.productInventorys) {
            test.productInventorys.sort((a, b) => {
                return a.product.name.localeCompare(b.product.name);
            });
        }
    }

    private renderReallocate = (row: IInventoryProduct, index: number) => (tabIndex: number) => {
        const testList = this.TestsStore.tests;
        let currTestIndex = -1;
        let isDisabled = false;
        if (testList !== undefined) {
            if (testList.length === 1) {
                isDisabled = true;
            } else {
                currTestIndex = testList.findIndex(test => test.id === this.state.test.id);
            }
        }
        if (currTestIndex >= 0) {
            const prevTest = testList[currTestIndex + 1];
            if (prevTest && prevTest.fluidType === this.state.test.mudProperties.fluidType && !this.state.test.isNewIntervalReport || !this.TestsStore.enableRecentTest()) {
                isDisabled = true;
            }
        }
        return (
            <EInput
                type="text"
                name="reallocation"
                data-max={row.amountUsed}
                data-validation={row.product.isBulk ? "decimal" : "integer"}
                decimal-places="2"
                value={row.reallocation}
                onChange={this.handleInputChange(index)}
                disabled={!this.state.test.isInventoryReport || isDisabled}
                tabIndex={tabIndex + 50}
            />
        );
    }

    private renderCategorySelect = (row: IInventoryProduct, index: number) => (tabIndex: number) => {
     const categoryName = this.state.test.productInventorys[index].category as never;
     const categoryList = this.state.productCategories;
     if(!categoryList.includes(categoryName)){
        this.state.productCategories.push(categoryName);
     }
        return (
            <EInput
                type="select"
                name="categoryId"
                value={row.category.id}
                onChange={this.handleInputChange(index)}
                disabled={!this.state.test.isInventoryReport || !this.TestsStore.enableRecentTest()}
                tabIndex={(tabIndex + 50)}
            >
                <option/>
                { this.state.productCategories && this.state.productCategories.map((productCategory: IProductCategory ,key: number) =>
                    <option key={key} value={productCategory.id}>{productCategory.name}</option>
                ) }
            </EInput>
        );
    }

    private renderPriceUsed = (row: IInventoryProduct, index: number) => (tabIndex: number) => {
        return (
            <EInput
                type="text"
                name="priceUsed"
                data-min={0}
                data-validation="decimal"
                data-mask="currency"
                value={row.priceUsed}
                onChange={this.handleInputChange(index)}
                disabled={
                    !this.state.test.isInventoryReport
                    || !this.TestsStore.enableRecentTest()
                    || !this.UserStore.hasPermission("Permissions.WellTests.EditProductPrice")
                }
                tabIndex={tabIndex + 50}
            />
        );
    }

    private renderAdjusted = (row: IInventoryProduct, index: number) => (tabIndex: number) => {
        return (
            <EInput
                type="text"
                name="adjustedStartingAmount"
                data-validation={row.product.isBulk ? "decimalnegative" : "negative"}
                decimal-places="2"
                value={row.adjustedStartingAmount}
                onChange={this.handleInputChange(index)}
                disabled={
                    !this.state.test.isInventoryReport
                    || !this.TestsStore.enableRecentTest()
                    || !this.UserStore.hasPermission("Permissions.WellTests.EditAdjustedAmount")
            }
                tabIndex={tabIndex + 50}
            />
        );
    }

    private renderReceived = (row: IInventoryProduct, index: number) => (tabIndex: number) => {
        return (
            <EInput
                type="text"
                name="amountReceived"
                data-min={0}
                data-validation={row.product.isBulk ? "decimal" : "integer"}
                decimal-places="2"
                value={row.amountReceived}
                onChange={this.handleInputChange(index)}
                disabled={true}
                tabIndex={tabIndex + 50}
            />
        );
    }

    private renderReturned = (row: IInventoryProduct, index: number) => (tabIndex: number) => {
        return (
            <EInput
                type="text"
                name="amountReturned"
                data-min={0}
                data-validation={row.product.isBulk ? "decimal" : "integer"}
                decimal-places="2"
                value={row.amountReturned}
                onChange={this.handleInputChange(index)}
                disabled={true}
                tabIndex={tabIndex + 50}
            />
        );
    }

    private renderClosing = (row: IInventoryProduct, index: number) => (tabIndex: number) => {
        return (
            <EInput
                type="text"
                name="closingAmount"
                data-validation={row.product.isBulk ? "decimalnegative" : "negative"}
                decimal-places="2"
                value={row.closingAmount}
                onChange={this.handleInputChange(index)}
                disabled={!this.state.test.isInventoryReport || !this.TestsStore.enableRecentTest()}
                tabIndex={tabIndex + 50}
            />
        );
    }

    private renderRawData = (ip: IInventoryProduct, name: string, mask?: any) => () => {
        if (mask) {
            return mask(ip[name]);
        }

        return ip[name];
    }

    private handleReorder = (startIndex: any, endIndex: any) => {
        const test = this.state.test;
        const result = test.productInventorys.sort((a,b) => a.defaultSortOrdinal - b.defaultSortOrdinal);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        result.forEach((val, index) => {
            val.defaultSortOrdinal = index;
        });
        this.setState({
            isDirty: true,
            test
        }, () => {
            this.formatDataTable();
        });
    }

    private changeDefaultSort = (indexes: number[], defaultSortName: string) => {
        const test = this.state.test;
        const result = test.productInventorys;
        result.forEach((val, index) => {
            val[defaultSortName] = indexes[index];
        });

        this.setState({
            isDirty: true,
            test
        }, () => {
            this.formatDataTable();
            this.MessageStore.addMessage("Your custom sort order has been set. Please save the page to save the custom sort order you set.", 'success', 3000);
        });
    }

    private renderProductDispatch = (row: IInventoryProduct) => {
        const test = this.state.test;
        const deliveryPending = test.deliveriesPending
            .reduce(
                (acc, dp) => acc + dp.trucks.filter(dt => dt.status !== 'EnRoute').reduce(
                    (iacc, t) => iacc + t.items.reduce(
                        (iiacc, i) => 
                            iiacc + (i.productId === row.product.id ? i.quantity : 0)
                        , 0)
                    , 0)
                , 0);

        const pickupPending = test.pickupsPending
            .reduce(
                (acc, dp) => acc + dp.trucks.filter(dt => dt.status !== 'EnRoute').reduce(
                    (iacc, t) => iacc + t.items.reduce(
                        (iiacc, i) => iiacc + (i.productId === row.product.id ? i.quantity : 0), 0)
                    , 0)
                , 0);
        const total = deliveryPending - pickupPending;
        return decimalPlaces(total) > 0 ? total.toFixed(2) : total.toString();
    }

    private formatDataTable() {
        const headers = [
            'Product',
            'Pending',
            'Size',
            'Unit',
            'SG',
            'Category',
            'Price',
            'Starting',
            'Adjusted',
            'Received',
            'Returned',
            'Closing',
            'Used',
            'Total',
            'Reallocate to Previous'
        ];

        
        const rows = this.state.test.productInventorys
            .filter(ip => ip.product.name.toLowerCase().includes(this.state.nameFilter.toLowerCase()))
            .map((ip, index) => {
            return [
                {
                    content: ip.product.name,
                },
                {
                    content: this.renderProductDispatch(ip),
                },
                {
                    content: ip.product.size,
                },
                {
                    content: ip.product.unit,
                },
                {
                    content: ip.product.specificGravity,
                },
                {
                    content: this.renderCategorySelect(ip, index),
                    sortItem: ip.category,
                    type: 'render',
                },
                {
                    content: this.renderPriceUsed(ip, index),
                    sortItem: ip.priceUsed,
                    type: 'render',
                },
                {
                    content: ip.startingAmount,
                },
                {
                    content: this.renderAdjusted(ip, index),
                    sortItem: ip.adjustedStartingAmount,
                    type: 'render',
                },
                {
                    content: this.renderReceived(ip, index),
                    sortItem: ip.amountReceived,
                    type: 'render',
                },
                {
                    content: this.renderReturned(ip, index),
                    sortItem: ip.amountReturned,
                    type: 'render',
                },
                {
                    content: this.renderClosing(ip, index),
                    sortItem: ip.closingAmount,
                    type: 'render',
                },
                {
                    content: this.renderRawData(ip, 'amountUsed'),
                    sortItem: ip.amountUsed,
                    type: 'render',
                },
                {
                    content: this.renderRawData(ip, 'totalCost', this.mask.currency),
                    sortItem: ip.totalCost,
                    type: 'render',
                },
                {
                    content: this.renderReallocate(ip, index),
                    sortItem: ip.reallocation,
                    type: 'render'
                },
                {
                    sortItem: ip.defaultSortOrdinal,
                    type: 'defaultSort'
                }
            ];
        });

        this.setState({
            dataSet: {
                headers,
                rows
            }
        });
    }

    private formatModalDataTable() {
        const newDataList: any[] = [];
        const newDataListMaster: any[] = [];

        const tableHeaders = [
            'Product',
            'Category',
            'Unit',
            'Size',
            'SG',
            'Weight',
            'Price'
        ];
        if ( this.state.productList ) {
            this.state.productList.map((product: IProduct, index: number) => {
                const newObject = [
                    {
                        content: product.name
                    },
                    {
                        content: product.categorys[0].name
                    },
                    {
                        content: product.unit
                    },
                    {
                        content: product.size
                    },
                    {
                        content: product.specificGravity
                    },
                    {
                        content: product.weight
                    },
                    {
                        content: product.retailPrice
                    }
                ];
                newDataList.push(newObject);
            });
        }

        if ( this.state.productListMaster ) {
            this.state.productListMaster.map(product => {
                const newObject = [
                    {
                        content: product.name
                    },
                    {
                        content: product.categorys[0].name
                    },
                    {
                        content: product.unit
                    },
                    {
                        content: product.size
                    },
                    {
                        content: product.specificGravity
                    },
                    {
                        content: product.weight
                    },
                    {
                        content: product.retailPrice
                    }
                ];
                newDataListMaster.push(newObject);
            });
        }

        const listStructure = {
            headers: tableHeaders,
            rows: newDataList
        };

        const listStructureMaster = {
            headers: tableHeaders,
            rows: newDataListMaster,
        };

        this.setState({
            modalDataSet: listStructure,
            modalDataSetMaster: listStructureMaster,
        });
    }

    public async componentWillUnmount() {
        this.clearDisposers();
    }

    public clearDisposers() {
        if ( this.testDisposer ) {
            this.testDisposer();
        }
        if ( this.wellDisposer ) {
            this.wellDisposer();
        }
    }

    private getProductList() {
        return this.TestsStore.getProductList(this.state.well.id)
        .then(
            (data: any) => {
                const productList: IProduct[] = [];
                data.forEach((product: IProduct) => {
                    if(!this.state.test.productInventorys.some(iip => iip.product.id === product.id)) {
                        productList.push(product);
                    }
                });
                
                this.setState({
                    productList
                }, () => {
                    this.formatModalDataTable();
                });
            }
        );
    }

    private getMasterProductList() {
        this.TestsStore.getProductMasterList()
            .then(productMasterList => {
                if (productMasterList) {
                    const productListMaster = productMasterList.filter((product: IProduct) =>
                        !this.state.productList.some(p => p.id === product.id)
                            && !this.state.test.productInventorys.some(iip => iip.product.id === product.id)
                    );
                    this.setState({productListMaster}, () => {
                        this.formatModalDataTable();
                    });
                }
            });
    }
    
    private handleListToggle = () => {
        this.setState({
            showMasterItems: !this.state.showMasterItems,
        });
    }

    public handleReceiveModalToggle = () => {
        this.setState({
            receiveDispatchModal: !this.state.receiveDispatchModal
        });
    }

    public handlePickupModalToggle = () => {
        this.setState({
            pickupDispatchModal: !this.state.pickupDispatchModal
        });
    }

    private handlePendingModalToggle = () => {
        this.setState({
            pendingDispatchModal: !this.state.pendingDispatchModal,
        });
    }

    private getProductCategories() {
        this.TestsStore.getProductCategories()
        .then(
            (data: any) => {
                this.setState({
                    productCategories: data
                });
            }
        );
    }

    private toggleModal = () => {
        if ( this.state.modal ) {
            this.getProductList();
            this.setState({
                newInventoryList: [],
                showMasterItems: false
            });
            
        }
        this.setState({
            modal: !this.state.modal
        }, () => {
            this.formatModalDataTable();
        });
    }

    // private toggleProductModal = () => {
    //     if ( this.state.productModal ) {
    //         this.setState({
    //             newProduct: new IProduct()
    //         });
    //     }
    //     this.setState({
    //         productModal: !this.state.productModal
    //     });

    // }

    private handleSave = () => {
        const test = this.state.test;
        const productInventorys = test.productInventorys;
        const productIndex: number[] = [];
        const masterProductIndex: number[] = [];
        this.state.productList.map((product: IProduct, index: number) => {
            if (this.state.newInventoryList[index]) {
                productIndex.unshift(index);
                const newInventoryProduct = new IInventoryProduct();
                newInventoryProduct.isTaxable = product.isTaxable;
                newInventoryProduct.product = product;
                newInventoryProduct.category = product.categorys[0];
                newInventoryProduct.priceUsed = product.retailPrice;
                productInventorys.push(newInventoryProduct);
            }
        });
        
        this.state.productListMaster.forEach((product: IProduct, index: number) => {
            if (this.state.newInventoryListMaster[index]) {
                masterProductIndex.unshift(index);
                const newInventoryProductMaster = new IInventoryProduct();
                newInventoryProductMaster.isTaxable = product.isTaxable;
                newInventoryProductMaster.product = product;
                newInventoryProductMaster.category = product.categorys[0];
                newInventoryProductMaster.priceUsed = product.retailPrice;
                productInventorys.push(newInventoryProductMaster);
            }
        });

        productIndex.forEach(value => {
            this.state.productList.splice(value, 1);
        });

        masterProductIndex.forEach(value => {
            this.state.productListMaster.splice(value, 1);
        });

        test.productInventorys = productInventorys;
        this.setState({
            isDirty: true,
            test
        }, () => {
            this.formatDataTable();
        });
        this.toggleModal();
    }

    private handleMultiSelect = (index: number) => {
        if (this.state.showMasterItems) {
            const newInventoryListMaster = this.state.newInventoryListMaster;
            newInventoryListMaster[index] = !newInventoryListMaster[index];
            this.setState({newInventoryListMaster});
        } else {
            const newInventoryList = this.state.newInventoryList;
            newInventoryList[index] = !newInventoryList[index];
            this.setState({newInventoryList});
        }
    }

    // private handleDelete = (index: number) => {
    //   const test = this.state.test;
    //    const productInventorys = this.state.test.productInventorys;
    //    productInventorys.splice(index, 1);
    //    test.productInventorys = productInventorys;
    //    this.setState({
    //        isDirty: true,
    //        test
    //    }, () => {
    //        this.formatDataTable();
    //    });
    // }

    public handleInputChange = (index: any) => (event: any) => {
        const eName = event.target.name;
        const test = this.state.test;
        const row = this.state.test.productInventorys[index];

        if (event.target.name === 'categoryId' ) {
            row.category.id = event.target.value;
        }

        row[event.target.name] = event.target.value;
        test.productInventorys[index] = row;

        this.setState({
            isDirty: true,
            test
        }, () => {
            if (eName !== 'reallocation') {
                this.newCalcMethod(index, eName);
            }
        });
    }

    // private handleSaveProduct = () => {
    //     const productList = this.state.productList;
    //     productList.push(this.state.newProduct);
    //     this.setState({
    //         newProduct: new IProduct(),
    //         productList
    //     }, () => {
    //         this.formatDataTable();
    //         this.formatModalDataTable();
    //         this.toggleProductModal();
    //     });
    // }

    public handleProductInputChange = (event: any) => {
        const newProduct = this.state.newProduct;
        if ( event.target.name === 'categorys' ) {
            if ( this.state.productCategories.length > 0 ) {
                this.state.productCategories.map((category: IProductCategory, index: number) => {
                    if (category.id === event.target.value) {
                        newProduct.categorys[0] = category;
                    }
                });
            }
        } else {
            newProduct[event.target.name] = event.target.value;
        }
        this.setState({
            newProduct
        });
    }

    public newCalcMethod = (index: any, target?: any) => {
        const test: ITest = toJS(this.state.test);
        const row = test.productInventorys[index];
        let closingAmount = Number(row.closingAmount);
        if (isNaN(closingAmount)) {
            return;
        }
        const price = Number(row.priceUsed) || 0;
        const startingAmount = Number(row.startingAmount) || 0;
        const adjustedStartingAmount = Number(row.adjustedStartingAmount) || 0;
        const amountReceived = Number(row.amountReceived) || 0;
        const amountReturned = Number(row.amountReturned) || 0;
        const calcAmountStarting = adjustedStartingAmount + startingAmount;
        const calcClosingAmount = calcAmountStarting + amountReceived - amountReturned;
        const closingAmountDirty = this.state.closingAmountDirty;
        if ( target !== 'closingAmount' && !closingAmountDirty[index] ) {
            closingAmount = calcClosingAmount;
        } else {
            closingAmountDirty[index] = true;
        }

        const calcAmountUsed = calcAmountStarting + amountReceived - amountReturned - closingAmount;

        test.productInventorys[index].closingAmount = closingAmount;
        test.productInventorys[index].amountUsed = calcAmountUsed;
        test.productInventorys[index].totalCost = price * calcAmountUsed;



        this.setState({
            closingAmountDirty,
            test
        });
    }

    private filterProductList = (event: any) => {
        this.setState({
            nameFilter: event.target.value,
        }, () => {
            this.formatDataTable();
        });
    }
    private updateTestModel = () => {
        this.TestsStore.updateTestModel(this.state.test, this.props.match.params.wellId).then((test:any) => {
            if (test) {
                this.setState({
                    isDirty: false,
                });
            }
        });
    }

    public handleChange = (test: ITest) => {
        this.setState({
            isDirty: true,
            test
        });
    }

    public handleReceiveTruck = (dispatchTruck: IDispatchTruck, dispatchIndex: number, truckIndex: number) => {
        const test = DeepCopy(this.state.test) as ITest;
        test.dispatchTrucksReceived.push(dispatchTruck);
        test.deliveriesPending[dispatchIndex].trucks[truckIndex].status = 'Completed';
        dispatchTruck.items.forEach(di => {
            if (!di.product) {
                return;
            }
            const dispatchProduct = test.productInventorys.find(pi => di.productId === pi.product.id);
            if (dispatchProduct) {
                dispatchProduct.amountReceived = Number(dispatchProduct.amountReceived) + Number(di.quantity);
                dispatchProduct.closingAmount = Number(dispatchProduct.closingAmount) + Number(di.quantity);
            } else {
                let product = this.state.productList.find(pli => pli.id === di.productId);
                if (!product) {
                    product = this.state.productListMaster.find(pli => pli.id === di.productId);
                }

                if (product && di.quantity > 0) {
                    const newInventoryProduct = new IInventoryProduct();
                    newInventoryProduct.isTaxable = product.isTaxable;
                    newInventoryProduct.product = product;
                    newInventoryProduct.category = product.categorys[0];
                    newInventoryProduct.priceUsed = product.retailPrice;
                    newInventoryProduct.startingAmount = 0;
                    newInventoryProduct.amountReceived = di.quantity;
                    newInventoryProduct.closingAmount = di.quantity;
                    test.productInventorys.push(newInventoryProduct);
                } else if (di.quantity > 0) {
                    this.MessageStore.addMessage(`Cannot Receive Product ${di.product.name}.`, 'danger');
                    return;
                }
            }
        });

        dispatchTruck.items.forEach(di => {
            if (!di.expense) {
                return;
            }
            const dispatchExpense = test.ebpInventorys.find(ei => di.expenseId === ei.expenseType.id);
            if (dispatchExpense && dispatchExpense.unitPrice === di.price) {
                dispatchExpense.quantity += di.quantity;
                if (!dispatchExpense.unit) {
                    dispatchExpense.unit = '1';
                }
            } else {
                let expense = this.state.expenseList.find(eli => eli.id === di.expenseId);
                if (!expense) {
                    expense = this.state.expenseListMaster.find(eli => eli.id === di.expenseId);
                }

                if (expense && di.quantity > 0) {
                    const newExpense = new IInventoryEBP();
                    newExpense.isRecurring = false;
                    newExpense.expenseType = expense;
                    newExpense.isTaxable = expense.isTaxable;
                    newExpense.unitPrice = di.price;
                    newExpense.quantity = di.quantity;
                    newExpense.unit = '1';
                    test.ebpInventorys.push(newExpense);
                } else if (di.quantity > 0) {
                    this.MessageStore.addMessage(`Cannot Receive EBP ${di.expense.name}.`, 'danger');
                    return;
                }
            }
        });

        this.TestsStore.updateTestModel(test, this.props.match.params.wellId).then((data:any) => {
            if (data) {
                this.setState({
                    isDirty: false,
                });
            }
        });
        this.setState({
            receiveDispatchModal: false,
        });
    }

    public handlePending = () => undefined;

    public handlePickupTruck = (dispatchTruck: IDispatchTruck, dispatchIndex: number, truckIndex: number) => {
        const test = DeepCopy(this.state.test) as ITest;
        const dispatchType = test.pickupsPending[dispatchIndex].type;
        test.dispatchTrucksReturned.push(dispatchTruck);
        test.pickupsPending[dispatchIndex].trucks[truckIndex].returnedWellTestId = this.state.test.id;
        dispatchTruck.items.forEach(di => {
            if (di.product) {
                const dispatchProduct = test.productInventorys.find(pi => di.productId === pi.product.id);
                if (dispatchProduct) {
                    if (Number(dispatchProduct.closingAmount) - Number(di.quantity) < 0) {
                        const overage = Number(di.quantity) - Number(dispatchProduct.closingAmount);
                        dispatchProduct.returnedOverage = overage;
                        dispatchProduct.amountReturned = (Number(dispatchProduct.amountReturned) + Number(di.quantity)) - overage;
                        dispatchProduct.closingAmount = (Number(dispatchProduct.closingAmount) - (Number(di.quantity)) + overage);
                        
                    } else {
                        dispatchProduct.amountReturned = Number(dispatchProduct.amountReturned) + Number(di.quantity);
                        dispatchProduct.closingAmount = Number(dispatchProduct.closingAmount) - Number(di.quantity);
                    }
                } else {
                    this.MessageStore.addMessage(`Cannot Pickup Product ${di.product.name}.`, 'danger');
                    return;
                }
            }

            if (di.expense) {
                const dispatchExpense = test.ebpInventorys.find(ei => di.expenseId === ei.expenseType.id);
                if (dispatchExpense && dispatchExpense.unitPrice === di.price && dispatchType === 'Pickup') {
                    if (!dispatchExpense.expenseType.isRental) {
                        dispatchExpense.quantity += Number(di.quantity);
                    }
                } else if (dispatchType === 'Pickup') {
                    let expense = this.state.expenseList.find(eli => eli.id === di.expenseId);
                    if (!expense) {
                        expense = this.state.expenseListMaster.find(eli => eli.id === di.expenseId);
                    }

                    if (expense && !expense.isRental) {
                        const newExpense = new IInventoryEBP();
                        newExpense.isRecurring = false;
                        newExpense.expenseType = expense;
                        newExpense.isTaxable = expense.isTaxable;
                        newExpense.unitPrice = di.price;
                        newExpense.quantity = di.quantity;
                        newExpense.unit = '1';
                        test.ebpInventorys.push(newExpense);
                    } else {
                        this.MessageStore.addMessage(`Cannot Pickup EBP ${di.expense.name}.`, 'danger');
                        return;
                    }
                }

                if (dispatchExpense) {
                    dispatchExpense.isRecurring = false;
                }
            }
        });
        
        this.TestsStore.updateTestModel(test, this.props.match.params.wellId).then((data:any) => {
            if (data) {
                this.setState({
                    isDirty: false,
                });
            }
        });
        this.setState({
            pickupDispatchModal: false,
        });
    }
    private buttonNavigation = (event: any) => {
        const $target = event.target;
        if ( $target.name === 'previous' ) {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/fluiddata/remarks');
        } else {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/inventory/ebp');
        }
    }

    private getAllPending = () => {
        const { deliveriesPending, pickupsPending } = this.state.test;
        return deliveriesPending.concat(pickupsPending).filter(p => p.trucks.some(t => t.status !== 'EnRoute'));
    }

    // public sortColumnHeader(columnName: string, event:any) {
    //     event.persist();

    //     const table: any = document.getElementById('sortableTable');
    //     let sortOrder = this.state.sortOrder;

    //     const data = this.state.test;

    //     //
    //     // This goes through and adds/removes classes based on sorting
    //     // This will help identify which column is sorted and in what order
    //     if ( table !== null ) {
    //         const tbody: any = table.getElementsByTagName('tbody')[0];
    //         const wasAsc:boolean = event.target.classList.contains('asc');
    //         const wasPreviouslySorted: boolean = event.target.classList.contains('asc', 'desc');
    //         const ths: any = table.getElementsByTagName('th');
    //         const tds: any = tbody.getElementsByTagName('td');
            
    //         if ( !wasPreviouslySorted ) {
    //             sortOrder = 1;
    //             this.setState({
    //                 sortOrder: 1
    //             });
    //         }

    //         for ( const th of ths ) {
    //             th.classList.remove('asc', 'desc');
    //         }

    //         for ( const td of tds ) {
    //             td.classList.remove('sorted');
    //         }

    //         for ( const row of tbody.rows ) {
    //             row.cells[event.target.cellIndex].classList.add('sorted');
    //         }

    //         if ( wasAsc ) {
    //             event.target.classList.add('desc');
    //         } else {
    //             event.target.classList.add('asc');
    //         }

    //     }

    //     if (data) {
    //         const sortedData = data.productInventorys.sort((a: IInventoryProduct, b:IInventoryProduct) => {
    //             if (columnName === 'name') {
    //                 return a.product.name.localeCompare(b.product.name) * sortOrder;
    //             }

    //             if (columnName === 'size') {
    //                 return (Number(a.product.size) - Number(b.product.size)) * sortOrder;
    //             }

    //             if (columnName === 'unit') {
    //                 return a.product.unit.localeCompare(b.product.unit) * sortOrder;
    //             }

    //             if (columnName === 'categoryId') {
    //                 return a.category.name.localeCompare(b.category.name) * sortOrder;
    //             }
    //             if (typeof a[columnName] === 'string' && isNaN(Number(a[columnName]))) {
    //                 return a[columnName].localeCompare(b[columnName]) * sortOrder;
    //             } else if (typeof a[columnName] === 'number' || !isNaN(Number(a[columnName]))) {
    //                 return (Number(a[columnName]) - Number(b[columnName])) * sortOrder;
    //             } else if (typeof a[columnName] === 'boolean') {
    //                 return (a[columnName] === b[columnName] ? 0 : a[columnName] ? -1 : 1) * sortOrder;
    //             } else {
    //                 return 0;
    //             }
    //         });
    //         data.productInventorys = sortedData;
    //         this.setState({
    //             sortOrder: sortOrder * -1,
    //             test: data,
    //         });

    //     }
    // }

    public render() {
        const enableProducts = this.state.test.isInventoryReport && this.state.test.testStatus !== 'Approved';
        const noFilter = this.state.nameFilter === '';
        return(
            <div className="Products">
                <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                <WorkflowHeader workflowHeaderItems={this.props.workflowHeaderItems} isInventoryReport={this.state.test.isInventoryReport}/>
                <Row>
                    <Col md="12">
                        <TotalHeader test={this.state.test} well={this.state.well} handleChange={this.handleChange} />
                    </Col>
                    <Col md="3" className="table-filter-input">
                        <Input
                            type="text"
                            name="nameFilter"
                            id="nameFilter"
                            placeholder="filter products by name"
                            value={this.state.nameFilter}
                            onChange={this.filterProductList}
                            autoComplete="off"
                        />
                    </Col>
                    {
                        this.state.test.testStatus !== 'Approved' &&
                        this.state.test.isInventoryReport &&
                        this.getAllPending().length > 0 &&
                        <Col>
                            <Button color="primary" onClick={this.handlePendingModalToggle}>View Pending Dispatches</Button>
                        </Col>
                    }
                    {
                        this.state.test.testStatus !== 'Approved' &&
                        this.state.test.isInventoryReport &&
                        this.state.test.deliveriesPending &&
                        this.state.test.deliveriesPending.filter(p => p.status === 'Confirmed').length > 0 &&
                        this.state.test.deliveriesPending.some(dp => dp.trucks.some(t => t.status === 'EnRoute')) &&
                        <Col>
                            <Button color="primary" onClick={this.handleReceiveModalToggle}>View Pending Deliveries</Button>
                        </Col>
                    }
                    {
                        this.state.test.testStatus !== 'Approved' &&
                        this.state.test.isInventoryReport &&
                        this.state.test.pickupsPending &&
                        this.state.test.pickupsPending.filter(p => p.status === 'Confirmed').length > 0 &&
                        this.state.test.pickupsPending.some(dp => dp.trucks.some(t => t.status !== 'EnRoute')) &&
                        <Col>
                            <Button color="primary" onClick={this.handlePickupModalToggle}>View Pending Pickups</Button>
                        </Col>
                    }
                    <Col md="12">
                        <DataTable
                            onNew={enableProducts ? {
                                callback: this.toggleModal,
                                text: 'Add Products',
                            } : undefined}
                            list={this.state.dataSet}
                            onReorder={enableProducts && noFilter ? this.handleReorder : undefined}
                            defaultSort={{
                                change: enableProducts && noFilter ? this.changeDefaultSort : undefined,
                                index: 15,
                                name: 'defaultSortOrdinal'
                            }}
                            varWidths={true}
                        />
                        {/* <div className="data-table-component">
                            <div className="scroll-wrapper">
                                <ValidatedForm validated={this.state.test.productInventorys}>
                                    <Table id="sortableTable" className="sortableTable">
                                        <thead className="stickyHeader">
                                            <tr>
                                                <th className="sortable" onClick={this.sortColumnHeader.bind(this, "name")}>Product</th>
                                                <th className="sortable" onClick={this.sortColumnHeader.bind(this, "size")}>Size</th>
                                                <th className="sortable" onClick={this.sortColumnHeader.bind(this, "unit")}>Unit</th>
                                                <th className="sortable" onClick={this.sortColumnHeader.bind(this, "specificGravity")}>SG</th>
                                                <th className="sortable" onClick={this.sortColumnHeader.bind(this, "categoryId")}>Category</th>
                                                <th className="sortable" onClick={this.sortColumnHeader.bind(this, "priceUsed")}>Price</th>
                                                <th className="sortable" onClick={this.sortColumnHeader.bind(this, "startingAmount")}>Starting</th>
                                                <th className="sortable" onClick={this.sortColumnHeader.bind(this, "adjustedStartingAmount")}>Adjusted</th>
                                                <th className="sortable" onClick={this.sortColumnHeader.bind(this, "amountReceived")}>Received</th>
                                                <th className="sortable" onClick={this.sortColumnHeader.bind(this, "amountReturned")}>Returned</th>
                                                <th className="sortable" onClick={this.sortColumnHeader.bind(this, "closingAmount")}>Closing</th>
                                                <th className="sortable" onClick={this.sortColumnHeader.bind(this, "amountUsed")}>Used</th>
                                                <th className="sortable" onClick={this.sortColumnHeader.bind(this, "totalCost")} >Total</th>
                                                {this.state.test.isInventoryReport && this.state.test.testStatus !== 'Approved' &&
                                                    <th>&nbsp;</th>
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            { this.state.test.productInventorys &&
                                                this.state.test.productInventorys.map((row: IInventoryProduct, index: number) =>
                                                    row.product.name.toLowerCase().includes(this.state.nameFilter.toLowerCase()) &&
                                                    <tr key={row.id !== "" ? row.id : index}>
                                                        <td>{row.product.name}</td>
                                                        <td>{row.product.size}</td>
                                                        <td>{row.product.unit}</td>
                                                        <td>{row.product.specificGravity}</td>
                                                        <td>
                                                        <EInput
                                                                type="select"
                                                                name="categoryId"
                                                                id="categoryId"
                                                                value={row.category.id}
                                                                onChange={this.handleInputChange(index)}
                                                                disabled={!this.state.test.isInventoryReport || this.state.test.testStatus === 'Approved'}
                                                                tabIndex={(index+11)+this.state.test.productInventorys.length}
                                                            >
                                                                <option/>
                                                                { this.state.productCategories && this.state.productCategories.map((productCategory: IProductCategory ,key: number) =>
                                                                    <option key={key} value={productCategory.id}>{productCategory.name}</option>
                                                                ) }
                                                            </EInput>
                                                        </td>
                                                        <td>
                                                            <EInput
                                                                type="text"
                                                                name="priceUsed"
                                                                id="priceUsed"
                                                                data-min={0}
                                                                data-validation="decimal"
                                                                data-mask="currency"
                                                                value={row.priceUsed}
                                                                onChange={this.handleInputChange(index)}
                                                                disabled={!this.state.test.isInventoryReport || this.state.test.testStatus === 'Approved'}
                                                                tabIndex={(index+11)+this.state.test.productInventorys.length*2}
                                                            />
                                                        </td>
                                                        <td>{row.startingAmount}</td>
                                                        <td>
                                                            <EInput
                                                                type="text"
                                                                name="adjustedStartingAmount"
                                                                id="adjustedStartingAmount"
                                                                data-validation="negative"
                                                                value={row.adjustedStartingAmount}
                                                                onChange={this.handleInputChange(index)}
                                                                disabled={!this.state.test.isInventoryReport || this.state.test.testStatus === 'Approved'}
                                                                tabIndex={(index+11)+this.state.test.productInventorys.length*3}
                                                            />
                                                        </td>
                                                        <td>
                                                            <EInput
                                                                type="text"
                                                                name="amountReceived"
                                                                id="amountReceived"
                                                                data-min={0}
                                                                data-validation="integer"
                                                                value={row.amountReceived}
                                                                onChange={this.handleInputChange(index)}
                                                                disabled={!this.state.test.isInventoryReport || this.state.test.testStatus === 'Approved'}
                                                                tabIndex={(index+11)+this.state.test.productInventorys.length*4}
                                                            />
                                                        </td>
                                                        <td>
                                                            <EInput
                                                                type="text"
                                                                name="amountReturned"
                                                                id="amountReturned"
                                                                data-min={0}
                                                                data-validation="integer"
                                                                value={row.amountReturned}
                                                                onChange={this.handleInputChange(index)}
                                                                disabled={!this.state.test.isInventoryReport || this.state.test.testStatus === 'Approved'}
                                                                tabIndex={(index+11)+this.state.test.productInventorys.length*5}
                                                            />
                                                        </td>
                                                        <td>
                                                            <EInput
                                                                type="text"
                                                                name="closingAmount"
                                                                id="closingAmount"
                                                                data-validation="negative"
                                                                value={row.closingAmount}
                                                                onChange={this.handleInputChange(index)}
                                                                disabled={!this.state.test.isInventoryReport || this.state.test.testStatus === 'Approved'}
                                                                tabIndex={(index+11)+this.state.test.productInventorys.length*6}
                                                            />
                                                        </td>
                                                        <td>{row.amountUsed}</td>
                                                        <td>{this.mask.currency(row.totalCost)}</td>
                                                        {this.state.test.isInventoryReport && this.state.test.testStatus !== 'Approved' &&
                                                            <td>
                                                                <div className="remove-row" onClick={this.handleDelete.bind(this, index)}>
                                                                    <FontAwesomeIcon icon={['far', 'trash-alt']}/>
                                                                </div>
                                                            </td>
                                                        }
                                                    </tr>
                                                ) }
                                        </tbody>
                                    </Table>
                                </ValidatedForm>
                            </div>
                            {this.state.test.isInventoryReport && this.state.test.testStatus !== 'Approved' &&
                                <div className="add-table-row">
                                    <Button color="primary" className="add-new-button" onClick={this.toggleModal}>
                                        <FontAwesomeIcon icon="plus" />
                                        { ' Add Products' }
                                    </Button>
                                </div>
                            }
                        </div> */}
                    </Col>
                </Row>
                <Footer 
                    well={this.WellsStore.well}
                    test={this.TestsStore.test}
                    onSave={this.updateTestModel}
                    onNavigate={this.buttonNavigation}
                    saveDisabled={!(this.state.test.isInventoryReport) || !this.TestsStore.enableRecentTest()}
                />
                <Modal isOpen={this.state.modal} fade={false} toggle={this.toggleModal} size="lg" backdrop="static">
                    <ModalHeader toggle={this.toggleModal}>Product List</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col md="12">
                                <DataTable
                                    list={this.state.showMasterItems ? this.state.modalDataSetMaster : this.state.modalDataSet}
                                    onMultiSelect={this.handleMultiSelect}
                                    multiSelectChecked={this.state.showMasterItems ? this.state.newInventoryListMaster : this.state.newInventoryList}
                                />
                            </Col>
                        </Row>
                        {/* 
                        MUD-2025  Archive the user defined product feature so comment for now.
                        This can be removed later if the feature is removed.
                        <div className="add-table-row">
                            <Button className="primary add-new-button" onClick={this.toggleProductModal}>
                                        <FontAwesomeIcon icon="plus" />
                                        { ' User Defined Product' }
                            </Button>
                        </div> */}
                        <div className="add-table-row">
                            <Button color={this.state.showMasterItems ? 'outline-primary' : 'primary'} onClick={this.handleListToggle}>{this.state.showMasterItems ? 'View Regional Items' : 'View Non-Regional Items'}</Button>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.toggleModal}>Cancel</Button>
                        <Button color="primary" onClick={this.handleSave}>Add to Inventory</Button>
                    </ModalFooter>
                </Modal>
                {
                    this.state.receiveDispatchModal &&
                    <ReceiveDispatchModal type="Delivery" dispatch={this.state.test.deliveriesPending} isOpen={this.state.receiveDispatchModal} toggleOpen={this.handleReceiveModalToggle} onReceive={this.handleReceiveTruck}/>
                }
                {
                    this.state.pickupDispatchModal &&
                    <ReceiveDispatchModal type="Pick Up" dispatch={this.state.test.pickupsPending} isOpen={this.state.pickupDispatchModal} toggleOpen={this.handlePickupModalToggle} onReceive={this.handlePickupTruck}/>
                }
                {
                    this.state.pendingDispatchModal &&
                    <ReceiveDispatchModal type="Pending" dispatch={this.getAllPending()} isOpen={this.state.pendingDispatchModal} toggleOpen={this.handlePendingModalToggle} onReceive={this.handlePending}/>
                }
                {/* 
                    This was commented when users were no longer allowed to make thier own products.
                    <Modal isOpen={this.state.productModal} fade={false} toggle={this.toggleProductModal}>
                    <ModalHeader toggle={this.toggleProductModal}> User Defined Product </ModalHeader>
                    <ModalBody>
                        <Form>
                            <Row>
                                <Col md="6">
                                    <FormGroup>
                                        <Label>Product</Label>
                                        <EInput
                                            type="text"
                                            name="name"
                                            id="name"
                                            value={this.state.newProduct.name}
                                            onChange={this.handleProductInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label>Category</Label>
                                        <EInput
                                            type="select"
                                            name="categorys"
                                            id="categorys"
                                            value={this.state.newProduct.categorys[0] ?
                                                this.state.newProduct.categorys[0].id : ''
                                            }
                                            onChange={this.handleProductInputChange}
                                            >
                                            <option />
                                            { this.state.productCategories && this.state.productCategories.map((productCategory: IProductCategory ,key: number) =>
                                                <option key={key} value={productCategory.id}>{productCategory.name}</option>
                                            ) }
                                        </EInput>
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label>Size</Label>
                                        <EInput
                                            type="text"
                                            name="size"
                                            id="size"
                                            value={this.state.newProduct.size}
                                            onChange={this.handleProductInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label>Unit</Label>
                                        <EInput
                                            type="text"
                                            name="unit"
                                            id="unit"
                                            value={this.state.newProduct.unit}
                                            onChange={this.handleProductInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label>Weight</Label>
                                        <EInput
                                            type="text"
                                            name="weight"
                                            id="weight"
                                            value={this.state.newProduct.weight}
                                            onChange={this.handleProductInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label>Specific Gravity</Label>
                                        <EInput
                                            type="text"
                                            name="specificGravity"
                                            id="specificGravity"
                                            value={this.state.newProduct.specificGravity}
                                            onChange={this.handleProductInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label>Price</Label>
                                        <EInput
                                            type="text"
                                            name="retailPrice"
                                            id="retailPrice"
                                            value={this.state.newProduct.retailPrice}
                                            onChange={this.handleProductInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.toggleProductModal}>Cancel</Button>
                        <Button color="primary" onClick={this.handleSaveProduct}>Add Product</Button>
                    </ModalFooter>
                </Modal> */}
            </div>
        );
    }
}

export default withRouter(Products);



// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/Inventory/Products/Products.tsx